import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
// import { editCompany } from '../../../Utils/Companies/editCompany';
import { httpCompanyLogo } from '../../../Hooks/admin/admin.post.hooks';
import { httpEditCompany } from '../../../Hooks/admin/admin.put.hooks';
import { formatNum } from '../../../Helpers/format-phone-number';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const PrimaryButton = React.lazy(
  () =>
    import('../../../Components/Buttons/PrimaryButton/PrimaryButton.component')
);
const Loader = React.lazy(
  () => import('../../../Components/Loader/LoaderComponent.component')
);

// Function for editing a company
const SubmitEditCompany = ({
  // user = {},
  company = {},
  setSuccessState,
  setIsOpen,
  logo = '',
}) => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ id, company }) => httpEditCompany(id, company),
    onSuccess: async (data) => {
      let message = await data.json();
      queryClient.invalidateQueries(['companies']);
      setSuccessState(message.msg || 'Company has been edited');
      setIsOpen(true);
    },
    onError: async (error) => {
      let err = await error.json();
      console.error('Error updating user:', error);
      setSuccessState(err.msg || 'Failed to edit company');
      setIsOpen(true);
    },
  });

  const editCompanySubmit = async (e) => {
    e.preventDefault();
    if (logo.name && logo) {
      const formData = new FormData();
      formData.append('logo', logo);
      formData.append('companyId', company._id);
      await httpCompanyLogo(formData);
    }
    const { phoneMobile, phoneOffice } = company;
    const companyPhone = await formatNum(phoneOffice);
    const mobilephone = await formatNum(phoneMobile);
    const updatedCompany = {
      ...company,
      phoneMobile: mobilephone,
      phoneOffice: companyPhone,
    };
    mutation.mutate({ id: company._id, company: updatedCompany });
  };

  return (
    <Suspense fallback={<p>Loading components...</p>}>
      {mutation.isPending ? (
        <Loader />
      ) : (
        <PrimaryButton functionName={editCompanySubmit} span="Edit Company" />
      )}
    </Suspense>
  );
};

SubmitEditCompany.propTypes = {
  // user: PropTypes.object,
  company: PropTypes.object,
  setSuccessState: PropTypes.func,
  setIsOpen: PropTypes.func,
  logo: PropTypes.string,
};

export default SubmitEditCompany;
